import { useContext } from 'react'
import { Button } from '@leroy-merlin-br/backyard-react-ui'

import { EntryKeyContext } from '../../context/EntryKeyContext'
import * as S from './styled'

const Sorters = () => {
  const {
    sorters,
    onOptionClick,
    query,
    pageInfo: { name: entryKeyName }
  } = useContext(EntryKeyContext)

  return (
    <S.Sorters>
      {sorters.map(({ slug, name }) => (
        <Button
          variant={query?.order?.value !== slug ? 'outline' : null}
          title={`${entryKeyName} ${name}`}
          size="kilo"
          key={slug}
          onClick={() => onOptionClick({
            name: 'order',
            value: slug,
            type: 'sorter',
            dataLayerOptions: {
              sorterType: name
            }
          })}
        >
          {name}
        </Button>
      ))}
    </S.Sorters>
  )
}

export default Sorters
